const mcuImportRoutes = [
    {
        path: '/mcu-import-data',
        name: 'mcuImports',
        children: [
            {
                path: '',
                name: 'mcuImportList',
                component: () => import('@/modules/mcu_import/list/List.vue'),
                meta: {
                    layout: 'default',
                    auth: true,
                    title: 'MCU Import',
                    breadcrumbs: [{ title: 'MCU Import Excel', routeName: 'mcuImportList' }]
                }
            }
        ]
    }
]

export default mcuImportRoutes
